export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/threshold/sturges.js
// module id = 108
// module chunks = 0